// extracted by mini-css-extract-plugin
module.exports = {"container":"AttachPriceToInvoiceModal_container____H7m","button":"AttachPriceToInvoiceModal_button__m1BmT"};